import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaComments, FaHourglass, FaMoneyBillWave, FaLeaf, FaMountain, FaChartLine, FaHiking, FaCalendarCheck, FaCalendarTimes, FaUser, FaChild, FaUserAlt, FaShuttleVan, FaBinoculars, FaRunning, FaShieldAlt, FaPassport, FaPlaneDeparture, FaHotel, FaMapMarkedAlt, FaLandmark, FaUmbrellaBeach, FaWater, FaCity, FaSwimmer, FaUtensils, FaGlobe } from 'react-icons/fa';
import { FaTent } from 'react-icons/fa6';



// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {

    /*----- Service Icons -----*/
    case 'tour packages':
      return <FaMapMarkedAlt />; // Hiking icon

    case 'hotel booking':
      return <FaHotel />; // Tent icon

    case 'flight booking':
      return <FaPlaneDeparture />; // Compass icon

    case 'airport transfers':
      return <FaShuttleVan />; // Group icon

    case 'visa assistance':
      return <FaPassport />; // Luggage icon

    case 'travel insurance':
      return <FaShieldAlt />; // Binoculars icon


    /*----- Activities Icons -----*/
    case 'sightseeing':
      return <FaBinoculars />; // Binoculars icon represents sightseeing tours

    case 'desert safari':
      return <FaShuttleVan />; // Safari jeep icon for desert safari experiences

    case 'cultural exploration':
      return <FaLandmark />; // Landmark icon representing cultural & heritage tours

    case 'beach & island tours':
      return <FaUmbrellaBeach />; // Beach umbrella icon for island & beach tours

    case 'adventure & hiking':
      return <FaHiking />; // Hiking icon representing adventure treks and hikes

    case 'water activities':
      return <FaWater />; // Water waves icon for water-based activities


    /*----- Category Icons -----*/
    case 'cultural heritage':
      return <FaLandmark />; // Landmark icon represents cultural & historical heritage

    case 'city exploration':
      return <FaCity />; // City skyline icon for urban/city tours

    case 'island adventures':
      return <FaUmbrellaBeach />; // Beach umbrella icon for island getaways

    case 'beach escapes':
      return <FaSwimmer />; // Swimming person icon for beach relaxation & water activities

    case 'mountain treks':
      return <FaHiking />; // Hiking icon for mountain treks

    case 'nature retreats':
      return <FaLeaf />; // Leaf icon symbolizes eco-tours & nature retreats

    case 'desert expeditions':
      return <FaShuttleVan />; // Safari van icon for desert exploration trips


    /*----- Page Sidebar -----*/
    case 'date':
      return <FaCalendarAlt />; // Calendar icon

    case 'time':
    case 'idealduration':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'cost':
    case 'budget':
    case 'price':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'tourguide':
    case 'organizer':
      return <FaUserTie />; // Leader icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Email icon

    case 'terraintype':
      return <FaMountain />; // Mountain icon

    case 'elevationrange':
      return <FaChartLine />; // Line chart icon

    case 'languagespoken':
      return <FaComments />; // Comments icon

    case 'currency':
      return <FaMoneyBillWave />; // Money icon

    case 'bestseason':
      return <FaLeaf />; // Leaf icon

    case 'tourtype':
      return <FaGlobe />; // Hiking icon

    case 'checkin':
      return <FaCalendarCheck />; // Check-in icon

    case 'checkout':
      return <FaCalendarTimes />; // Check-out icon

    case 'person':
      return <FaUser />; // User icon

    case 'minage':
      return <FaChild />; // Child icon

    case 'maxage':
      return <FaUserAlt />; // Adult icon

    case 'accommodation':
      return <FaTent />; // Tent icon

    case 'transportation':
      return <FaShuttleVan />; // Van icon

    case 'cuisine':
      return <FaUtensils />; // Utensils icon

    case 'activity':
      return <FaRunning />; // Running icon

    default:
      return null; // Return null if no matching icon is found
  }

};